var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "currentColor",
  viewBox: "0 0 28 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.307 25.217.161 14.889l1.426-1.401 8.52 8.672L26.242.783l1.598 1.205z"
})));
export default SvgCheckmark;